export default __webpack_public_path__ + "static/media/CarExteriorDetailing.96d2eccf.webp";